import styled from 'styled-components';
import { parseColor } from '../../../styles';
import { toBigWithDefault } from '../../../utils';

export const ATTACHED_PROGRESS_BAR_HEIGHT = 4;

interface AttachedProgressBarProps {
  value?: string | number | null;
  max?: string | number | null;
  color?: string;
}

export function AttachedProgressBar({ value, max, color }: AttachedProgressBarProps) {
  const filled = toBigWithDefault(value, 0);
  const total = toBigWithDefault(max, 0);
  const percent = total.eq(0) ? 0 : Math.min(filled.div(total).times(100).toNumber(), 100);

  return (
    <Track data-testid="attached-progress-bar">
      <Fill data-testid="attached-progress-bar-fill" $percent={percent} $color={color} />
    </Track>
  );
}

const Track = styled.div`
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  height: ${ATTACHED_PROGRESS_BAR_HEIGHT}px;
  overflow: hidden;
  background: ${({ theme }) => theme.backgroundProgressBar};
  pointer-events: none;
`;

const Fill = styled.div.attrs<{ $percent: number }>(({ $percent }) => ({
  style: { width: `${$percent}%` },
}))<{ $percent: number; $color?: string }>`
  height: 100%;
  background: ${({ theme, $color }) => ($color ? parseColor(theme, $color) : theme.backgroundProgressBarMeter)};
`;
